module.exports = __webpack_public_path__ + "4cc02acdc212d73faf0f131d9ca76746.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/background.png
// module id = 239
// module chunks = 0